import { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import MaDashboard from "pages/ma/dashboard";
import DeDashboard from "pages/de/dashboard/newDashboard";
import CircularProgress from "@mui/material/CircularProgress";

import SuiTypography from "components/SuiTypography";
import SuiBox from "components/SuiBox";

import Grid from "@mui/material/Grid";
import { Card } from "@mui/material";

import { AccountContext } from "context/account";
import MyProjectsContext from "context/my-projects";

import VideoPlayCard from "pages/create/components/VideoPlayCard";
import VideoPlayCard2 from "pages/create/components/VideoPlayCard2";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

import colors from "assets/theme/base/colors";
import { compare } from "utils/helper";
import {
  canResizeImageUrl,
  getStyleImages,
  getFileImage,
  getOnLineTechPackImages,
} from "utils/imageHelper";

import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import api from "services/api";

import BlogCard from "pages/blog/blogcard";

import StyleCard2 from "components/UpStyled/StyleCard2";
import ProjectCard4 from "components/UpStyled/project-card/ProjectCard4";
import MoodboardCard2 from "pages/de/collection/moodboards/components/MoodboardCard2";
import RecentWorkCard from "pages/create/components/RecentWorkCard";
import { detailAILabUrlPrefix } from "utils/data";

import { Empty } from "antd";
import curved9 from "assets/images/upstyled/default_background.png";
import toast from "react-hot-toast";

const MAX_RECENT_COUNT = 3;

const CreatePage = () => {
  const [projectList, setProjectList] = useState([]);
  const [styleList, setStyleList] = useState({ hits: [] });
  const [moodboards, setMoodboards] = useState([]);
  const [ailabList, setAilabList] = useState([]);

  const navigate = useNavigate();

  const account = useContext(AccountContext);
  const {
    stagesProjects,
    prospects,
    removeMyFavoriteProject,
    addUnFavoriteProject,
    handleRefresh,
  } = useContext(MyProjectsContext);

  useEffect(() => {
    if (account.id) {
      handleRefresh();
      retrieveStyles();
      retrieveMoodboards();
      retrieveAILabs();
    }
  }, [account]);

  useEffect(() => {
    if (account.id) {
      retrieveProjects("all");
    }
    //retrieveChats();
  }, [stagesProjects, account]);

  const retrieveMoodboards = async () => {
    try {
      const { data } = await api.moodboard.list();
      let myMoodboard = data?.moodboards || [];
      myMoodboard = myMoodboard.sort((a, b) => compare(a, b, "-updated_at"));

      setMoodboards(myMoodboard.slice(0, MAX_RECENT_COUNT));
    } catch (err) {
      toast.error(`Retrieve moodboards failed!`);
      console.log(err);
    }
  };

  const retrieveAILabs = async () => {
    try {
      const { data } = await api.ailab.list();
      let myAILab = data?.ailabs || [];
      myAILab = myAILab.sort((a, b) => compare(a, b, "-updated_at"));

      setAilabList(myAILab.slice(0, MAX_RECENT_COUNT));
    } catch (err) {
      toast.error(`Retrieve ailabs failed!`);
      console.log(err);
    }
  };

  const retrieveStyles = async () => {
    const payload = {
      q: "",
      sort: ["updated_at:desc"],
      limit: MAX_RECENT_COUNT,
    };

    try {
      const { data } = await api.products.searchStyles(payload);
      setStyleList(data ? data : { hits: [], nbHits: 0 });
    } catch (err) {
      toast.error(`Retrieve style list failed`);
      console.log(err);
    }
  };

  const retrieveProjects = async (stage) => {
    let projects = [];
    if (stage == "prospects") {
      projects = prospects;
    } else {
      projects = stagesProjects[stage] || [];
    }

    const sortedProjects = projects.sort((a, b) => compare(a, b, "-updated_at"));

    setProjectList(sortedProjects.slice(0, MAX_RECENT_COUNT));
  };

  let myAilabList = ailabList.map((x) => ({ ...x, displayType: "ailab" }));
  let myMoodboards = moodboards.map((x) => ({ ...x, displayType: "moodboard" }));
  let myStyles = styleList.hits.map((x) => ({ ...x, displayType: "style" }));
  let myProjects = projectList.map((x) => ({ ...x, displayType: "project" }));
  const recentWorks = [...myAilabList, ...myMoodboards, ...myStyles, ...myProjects].sort((a, b) =>
    compare(a, b, "-updated_at")
  );

  const data2 = [
    {
      title: "AI Design",
      description:
        "Inspire your ideas using text-to-image and image variation, enable you to conjure up fashionable attire from mere sketches and fabric swatches.",
      textProps: {
        color: colors.text.main,
      },
      cardProps: {
        backgroundColor: colors.lilac.main,
      },
      src: "https://upstyledus.oss-us-east-1.aliyuncs.com/www/videos/create-image-transformation.mp4",
      imgSrc:
        "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/tyIJqo2-cq0G5TGaDZ9OJ/create-fashion-lab.png",

      //link: "/create/ailab?tab=image-transformation",
      link: "/workspace/fashion-lab",
    },
    {
      title: "Moodboard",
      description: "Inspire Your Mood: Create with Images, Colors, Videos, and Songs!",
      textProps: {
        color: colors.text.main,
      },
      cardProps: {
        backgroundColor: colors.pink.main,
      },
      src: "https://upstyledus.oss-us-east-1.aliyuncs.com/www/videos/create-moodboard.mov",
      imgSrc:
        "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/4P0CFEqcn_exROnhg-2ar/create-moodboard.jpeg",
      link: "/create/moodboard",
    },
    {
      title: "Style",
      description:
        "Easily organize, and manage all design information, including prices, colorways, sizes, and more.",
      textProps: {
        color: colors.white.main,
      },
      cardProps: {
        backgroundColor: colors.red.main,
      },
      src: "https://upstyledus.oss-us-east-1.aliyuncs.com/www/videos/create-style.mov",
      imgSrc:
        "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/4P0CFEqcn_exROnhg-2ar/create-style.jpeg",
      link: "/create/style",
    },
    {
      title: "Tech Pack",
      description: "Factory-Ready Tech Packs: Simplify your Tech Pack creation process.",
      textProps: {
        color: colors.text.main,
      },
      cardProps: {
        backgroundColor: colors.tan.main,
      },
      src: "https://upstyledus.oss-us-east-1.aliyuncs.com/www/videos/create-techpack.mov",
      imgSrc:
        "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/4P0CFEqcn_exROnhg-2ar/create-techpack.jpeg",
      link: "/create/tech-pack",
    },
    {
      title: "Social Post",
      description:
        "Engage with your community: Share designs, launches, and updates with our social post feature.",
      textProps: {
        color: colors.white.main,
      },
      cardProps: {
        backgroundColor: colors.brown.main,
      },
      src: "https://upstyledus.oss-us-east-1.aliyuncs.com/www/videos/create-post.mov",
      imgSrc:
        "https://upstyledus.oss-us-east-1.aliyuncs.com/resources/UpStyled/online_resource/4P0CFEqcn_exROnhg-2ar/create-post.jpeg",
      link: "/post/create",
    },
  ];

  const height = 320;
  const width = 240;

  return (
    <SuiBox>
      <SuiBox mb={2} mt={4}>
        <SuiTypography variant="h4" textTransform="none" color="dark">
          Design Studios
        </SuiTypography>{" "}
      </SuiBox>
      <ResponsiveMasonry columnsCountBreakPoints={{ 300: 1, 550: 2, 850: 3, 1200: 4, 1400: 5 }}>
        <Masonry gutter="16px">
          {data2.map((x) => (
            <VideoPlayCard2
              src={x.src}
              imgSrc={x?.imgSrc}
              title={x.title}
              description={x.description}
              textProps={x?.textProps}
              cardProps={x?.cardProps}
              handleClick={() => (x.link ? navigate(x.link) : null)}
            />
          ))}
        </Masonry>
      </ResponsiveMasonry>

      {recentWorks.length > 0 ? (
        <div>
          <SuiBox mb={2} mt={4}>
            <SuiTypography variant="h4" textTransform="none" color="dark">
              Recent Works
            </SuiTypography>
          </SuiBox>

          <ResponsiveMasonry
            columnsCountBreakPoints={{ 240: 1, 480: 2, 700: 3, 950: 4, 1200: 5, 1400: 6 }}
          >
            <Masonry gutter="16px">
              {recentWorks.map((x, index) => {
                if (x.displayType == "moodboard") {
                  return (
                    <div index={index}>
                      <RecentWorkCard
                        handleClick={() => navigate(`/workspace/moodboard?id=${x.id}`)}
                        image={x?.img}
                        title={x?.name}
                        height={height}
                        width={width}
                        badge="Moodboard"
                        badgeColor="geekblue"
                      />
                    </div>
                  );
                } else if (x.displayType == "ailab") {
                  return (
                    <div index={index}>
                      <RecentWorkCard
                        handleClick={() => navigate(`${detailAILabUrlPrefix}/${x.id}`)}
                        image={x?.img}
                        title={x?.name}
                        height={height}
                        width={width}
                        badge="AI Design"
                      />
                    </div>
                  );
                } else if (x.displayType == "style") {
                  const metaFilesKey = ["imageFiles", "techPacksFiles", "referenceFiles"];
                  let styleImages = getStyleImages(x, false, metaFilesKey);

                  return (
                    <div index={index}>
                      <RecentWorkCard
                        handleClick={() => navigate(`/workspace/styles-master?id=${x.id}`)}
                        image={styleImages?.[0]}
                        title={x?.title}
                        height={height}
                        width={width}
                        badge="Style"
                        badgeColor="magenta"
                      />
                    </div>
                  );
                } else if (x.displayType == "project") {
                  const metadata = x?.metadata ? x.metadata : {}; //project metadata
                  const products = x?.products || [];
                  let styleImages = [];
                  //add style first image
                  for (let i = 0; i < products.length; i++) {
                    const temp = getStyleImages(products[i], false);

                    styleImages.push(...temp);
                  }
                  //add all project reference image
                  const fileList = metadata["othersFiles"] || [];
                  const files = fileList.filter((f) => f?.type && f.type.includes("image"));
                  if (files && files.length > 0) {
                    styleImages.push(...files);
                  }
                  if (styleImages.length == 0) {
                    styleImages = [{ url: curved9, name: "deafult_image" }];
                  }

                  return (
                    <div index={index}>
                      <RecentWorkCard
                        handleClick={() => navigate(`/produce/all-projects?id=${x.id}`)}
                        image={styleImages?.[0]}
                        title={x?.name}
                        height={height}
                        width={width}
                        badge="Project"
                        badgeColor="orange"
                      />
                    </div>
                  );
                } else {
                  return null;
                }
              })}
            </Masonry>
          </ResponsiveMasonry>
        </div>
      ) : (
        <div style={{ width: "100%" }}>
          <Empty description={null} />
        </div>
      )}
    </SuiBox>
  );
};

export default CreatePage;
